export default {
    // /////////////////////////////////////////////
    // BOOKING
    // /////////////////////////////////////////////

    UPDATE_BOOKING_EVENTS(state, payload) {
        state.BookingEvents = payload.map(item => Object.seal(item));
    },
}